export const getClientLocation = () =>
  fetch("http://ip-api.com/json", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  }).then((response) => response.json());
